import FPOList from "./FPOList";
import FPOLeadsList from "./FPOLeadsList";
import * as React from "react";
import { Card } from "reactstrap";
import HeaderTab from "../HeaderTab";
import TabSection from "components/TabSection";
import FarmerRequest from "features/onboarding/users/farmer/FarmerRequest";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "features/auth/authSlice";

const FPOContainer = () => {
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const pathname = window.location.pathname;

  return (
    <>
      {pathname.includes("/onboarding/fpo") ||
      pathname.includes("/org-dashboard") ||pathname.includes("/project/dashboard") ? (
        ""
      ) : (
        <HeaderTab params="FPO" />
      )}
      <Card className="mt-2" style={{ padding: "13px" }}>
        <TabSection
          tabsList={[
            {
              label: "FPO LIST",
              className: "f300",
              component: <FPOList />,
            },
            {
              label: "FPO LEADS",
              className: "f300",
              component: <FPOLeadsList />,
            },
            RoleAcessParams.includes("admin") && {
              label: "FARMER REQUEST",
              className: "f300",
              component: <FarmerRequest />,
            },
          ].filter((tab) => tab)}
          currentTab={0}
        />
      </Card>
    </>
  );
};

export default FPOContainer;
